import { CollectCoin } from '@/components/CollectCoin'
import { PageRoutes } from '@/constants/PageRoutes'
import classNames from 'classnames'
import { useI18n } from 'i18n-utils'
import { useKlineStore, useResponsive, useUserInfoStore } from 'store'
import { CustomButton, DialogHeader, HocElDialog, Visible } from 'ui-components'
import '../styles/trade-orderer-layout.scss'
import { OrdererBuy } from './OrdererBuy'
import { OrdererSell } from './OrdererSell'

enum TabType {
  Buy = 'buy',
  Sell = 'sell',
}

export const TradeOrderer = defineComponent({
  setup() {
    const { t } = useI18n()
    const activeTab = ref(TabType.Buy)
    const responsive = useResponsive()
    const openOrderer = ref(false)
    const currentOrderType = ref<'buy' | 'sell'>()
    const klineStore = useKlineStore()
    const userInfoStore = useUserInfoStore()
    const router = useRouter()

    const handleTabChange = (tab: TabType) => {
      activeTab.value = tab
    }

    const onBuy = () => {
      if (!userInfoStore.isLogin) {
        router.push(PageRoutes.Login)
        return
      }
      openOrderer.value = true
      currentOrderType.value = 'buy'
    }

    const onSell = () => {
      if (!userInfoStore.isLogin) {
        router.push({
          path: PageRoutes.Register,
          query: {
            entry: 'spot_trade',
          },
        })
        return
      }
      openOrderer.value = true
      currentOrderType.value = 'sell'
    }

    const onClose = () => {
      openOrderer.value = false
      currentOrderType.value = undefined
    }

    return () => {
      if (!responsive.isMobile) {
        return (
          <div class="trade-orderer-layout">
            <div class="title">
              <span>{t('现货')}</span>
            </div>
            <div class="orderer-box">
              <div class="tabs">
                <div class={classNames('tab buy-tab', { active: activeTab.value === TabType.Buy })} onClick={() => handleTabChange(TabType.Buy)}>
                  <span> {t('买入')}</span>
                </div>
                <div class={classNames('tab sell-tab', { active: activeTab.value === TabType.Sell })} onClick={() => handleTabChange(TabType.Sell)}>
                  <span> {t('卖出')}</span>
                </div>
              </div>
              <Visible class={'orderer-item'} visible={activeTab.value === TabType.Buy}>
                <OrdererBuy activeTab={activeTab.value} />
              </Visible>
              <Visible class={'orderer-item'} visible={activeTab.value === TabType.Sell}>
                <OrdererSell activeTab={activeTab.value} />
              </Visible>
            </div>
          </div>
        )
      }
      return (
        <div class="trade-orderer-layout">
          <div class="mobile-orderer-box">
            <div class="mobile-orderer-button">
              <CustomButton type={'primary'} primaryColor="var(--colors-up)" onClick={onBuy}>
                {userInfoStore.isLogin ? t('买入') : t('登录')}
              </CustomButton>
              <CustomButton type={'primary'} primaryColor="var(--colors-down)" onClick={onSell}>
                {userInfoStore.isLogin ? t('卖出') : t('注册')}
              </CustomButton>
              <div class={'collect-wrapper'}>
                <CollectCoin symbolId={klineStore.currentSymbolId!} />
                <span class={'collect-text'}>{t('自选')}</span>
              </div>
            </div>

            <HocElDialog v-model={openOrderer.value} showClose={false} placement="bottom" onClose={onClose}>
              {{
                header: () => <DialogHeader onClose={onClose}>{t('现货')}</DialogHeader>,
                default: () => {
                  if (currentOrderType.value === 'buy') {
                    return <OrdererBuy activeTab={currentOrderType.value} onClose={onClose} />
                  }
                  return <OrdererSell activeTab={currentOrderType.value} onClose={onClose} />
                },
              }}
            </HocElDialog>
          </div>
        </div>
      )
    }
  },
})
